import Vue from 'vue'
import gql from 'graphql-tag'

const query = gql`
  query kpiPeople (
    $name: String,
    $nameOrDocumentNumber: String,
    $id: ID,
    $status: String,
    $dateStart: ISO8601Date,
    $dateEnd: ISO8601Date,
    $campaignId: ID
  ) {
    kpiPeople (
      name: $name,
      nameOrDocumentNumber: $nameOrDocumentNumber,
      id: $id,
      status: $status,
      dateStart: $dateStart,
      dateEnd: $dateEnd,
      campaignId: $campaignId
    ) {
      peoplePaidCount
      peopleRegisteredCount
      peopleRegisteringCount
      peopleExpiredCount
      peopleImportedCount
      peopleFailAtCreateCount
      peopleFailAtRegisterCount
    }
  }
`

/**
* @param {*} pagnamee
* @param {*} nameOrDocumentNumber
* @param {*} id
* @param {*} status
* @param {*} dateStart
* @param {*} dateEnd
* @param {*} campaignId
**/

async function getPeopleKpi( params = {} ) {
  const { $api } = Vue.prototype
  const data = await $api.query({
    query,
    fetchPolicy: 'no-cache',
    variables: params
  }).then( res => res )
  .catch( e => e )
  return data
}

export { getPeopleKpi }
